import Footer from "./footer";
import Header from "./header";


const Layout = ({ children, isLanding = false, scrollFunctions = {} }) => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header isLanding={isLanding} scrollFunctions={scrollFunctions}/>

      <main className="flex-grow-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
